/**
 * Centralised API + WebSocket base URL resolution.
 * Replaces the brittle inline ternaries previously in App.tsx / LiveTracking.tsx.
 *
 *   REACT_APP_API_URL=""             -> use same-origin (Caddy in front of API)
 *   REACT_APP_API_URL="https://x"    -> explicit URL
 *   undefined + Capacitor            -> production URL
 *   undefined + browser dev          -> http://<hostname>:8000
 */
const envUrl = process.env.REACT_APP_API_URL;

const isCapacitor = (): boolean =>
  typeof window !== 'undefined' &&
  (window.location.protocol === 'capacitor:' ||
    (window.location.hostname === 'localhost' && window.location.port === ''));

function resolveApiBase(): string {
  if (envUrl !== undefined && envUrl !== '') return envUrl;
  if (envUrl === '') {
    return typeof window !== 'undefined'
      ? `${window.location.protocol}//${window.location.host}`
      : '';
  }
  if (isCapacitor()) {
    return process.env.REACT_APP_PROD_URL || 'https://provisionmart.com';
  }
  return typeof window !== 'undefined'
    ? `http://${window.location.hostname}:8000`
    : 'http://localhost:8000';
}

export const API_BASE_URL = resolveApiBase();

export const WS_BASE_URL = (() => {
  const base = API_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '');
  return base.replace(/^http/, 'ws');
})();

